import { render, staticRenderFns } from "./administrativeNotifier.vue?vue&type=template&id=855d8ebc"
import script from "./administrativeNotifier.vue?vue&type=script&lang=js"
export * from "./administrativeNotifier.vue?vue&type=script&lang=js"
import style0 from "./administrativeNotifier.vue?vue&type=style&index=0&id=855d8ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports